import type { FC } from 'react';
import { Box, Grid2 } from '@mui/material';
import { NavLink } from './NavLink';

interface IProps {
  activeLink: string;
}

const NavItem = [
  { label: '行业文章', href: '/industry-article' },
  {
    label: '专家互动论坛',
    href: '/expert-interactive-forum',
  },
];

const NewsNav: FC<IProps> = ({ activeLink }) => {
  return (
    <Box sx={{ minWidth: '300px' }}>
      <Grid2 container size={12}>
        <Grid2 size={12}>
          {NavItem.map((sub) => (
            <NavLink activeLink={activeLink} url={sub.href} title={sub.label} />
          ))}
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default NewsNav;
